import { useMutation, useQueryClient } from '@tanstack/react-query'
import { renameConversation } from '../../../data/statsAssistant'
import { UserFriendlyError } from '../../../model/Error'
import { StatsConversationDetail } from '../../../model/StatsAssistant'
import { statsAssistantKeys } from './statsAssistant.keys'
import { patchConversationSummary } from './statsAssistant.utils'

interface RenameParams {
  ulid: string
  title: string
}

export const useRenameConversation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ ulid, title }: RenameParams) => {
      const { ok } = await renameConversation(ulid, title)
      if (!ok) {
        throw new UserFriendlyError(
          'error',
          'Impossible de renommer la conversation',
          'Une erreur technique s’est produite',
        )
      }
    },
    onSuccess: (_data, { ulid, title }) => {
      queryClient.setQueryData<StatsConversationDetail>(
        statsAssistantKeys.conversation(ulid),
        (current) => (current ? { ...current, title } : current),
      )
      patchConversationSummary(queryClient, ulid, { title })
    },
  })
}
